module.exports = __webpack_public_path__ + "img/start.070d5563.svg";